import { Time } from "./time";
import { Limit } from "./limit";
import { UserJourney } from "@modules/shared/terms-and-conditions/entities/terms-and-conditions.model";

export interface ISavingsPlanExampleFeeBenefit {
	fee_discount?: number;
	eligibleForVsn?: boolean;
}

export class SavingsPlanExample extends Limit {
	private next_at: Time = new Time();
	private frequencies: TimeFrequency[] = [];
	private lead_time_days: number = 0;
	private interval: number = 0;
	private instant_trade_bonus_rate: string = "";
	private user_journey: UserJourney = UserJourney.SavingsPlanCardCryptoMetalIndex;
	private vsn_fee_token_collection: ISavingsPlanExampleFeeBenefit = {};

	public getNextAt(): Time {
		return this.next_at;
	}

	public getInterval(): number {
		return this.interval;
	}

	public getUserJourney(): UserJourney {
		return this.user_journey;
	}

	public getLeadTimeDays(): number {
		return this.lead_time_days;
	}

	public getPlanFrequencies(): TimeFrequency[] {
		return this.frequencies;
	}

	public getITBRate(): string {
		return this.instant_trade_bonus_rate;
	}

	public getVsnFeeTokenCollection(): ISavingsPlanExampleFeeBenefit {
		return this.vsn_fee_token_collection;
	}
}

export class TimeFrequency {
	public is_default: boolean = false;
	public label: string = "";
	public name: string = "";
	public range: TimeRange[] = [];
}

export class TimeRange {
	public name: string = "";
	public number: string = "";
	public is_default: boolean = false;
}
